import { getCzechPieces } from "./translation";

type QuantityTooltipOptions = {
    cartAmount: number;
    minOrder: number;
    granularity: number;
    language: string;
    itemType?: "product" | "service";
};
// Get correct "piece" word
const getEnglishPiecesWord = (count: number) => (count === 1 ? "piece" : "pieces");
const getPiecesWord = (language: string, count: number, kind: "amount" | "granularity") => {
    if (language === "cz") {
        return getCzechPieces(count, kind);
    }
    return getEnglishPiecesWord(count);
};

// Tooltip with quantity
export const getQuantityTooltip = ({
    cartAmount,
    minOrder,
    granularity,
    language,
    itemType = "product",
}: QuantityTooltipOptions) => {
    const piecesWord = getPiecesWord(language, minOrder, "amount");
    const granularityWord = getPiecesWord(language, granularity, "granularity");

    if (cartAmount <= minOrder) {
        if (language === "cz") {
            return `Minim\u00e1ln\u00ed mno\u017estv\u00ed do objedn\u00e1vky je ${minOrder} ${piecesWord}`;
        }
        return `Minimal order amount is ${minOrder} ${piecesWord}`;
    }

    if (itemType === "service") {
        if (language === "cz") {
            return `Slu\u017eba mus\u00ed b\u00fdt p\u0159id\u00e1na po ${granularity} ${granularityWord}`;
        }
        return `Service must be added in the groups of ${granularity} ${granularityWord}`;
    }

    if (language === "cz") {
        return `Produkt mus\u00ed b\u00fdt p\u0159id\u00e1n po ${granularity} ${granularityWord}`;
    }
    return `Product must be added in the groups of ${granularity} ${granularityWord}`;
};
